/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Workflow_HistoryInputs */

const en_sch_err_workflow_history = /** @type {(inputs: Sch_Err_Workflow_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items have used this workflow, so it cannot be deleted. Archive it instead.`)
};

const de_sch_err_workflow_history = /** @type {(inputs: Sch_Err_Workflow_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorgänge haben diesen Workflow genutzt, er lässt sich deshalb nicht löschen. Archiviere ihn stattdessen.`)
};

/**
* | output |
* | --- |
* | "Items have used this workflow, so it cannot be deleted. Archive it instead." |
*
* @param {Sch_Err_Workflow_HistoryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_workflow_history = /** @type {((inputs?: Sch_Err_Workflow_HistoryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Workflow_HistoryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_workflow_history(inputs)
	return en_sch_err_workflow_history(inputs)
});